import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { ArrowUp, ArrowDown, X, Plus } from "lucide-react";

export const AutoBuyCard = () => {
  const [on, setOn] = useState(false);
  const [order, setOrder] = useState([]);
  const [mlos, setMlos] = useState([]);
  const [pick, setPick] = useState("");
  useEffect(() => {
    api.get("/admin/settings").then((r) => { setOn(!!r.data.marketplace_autobuy_enabled); setOrder(r.data.marketplace_autobuy_mlos || []); }).catch(() => {});
    api.get("/admin/users").then((r) => setMlos(r.data.filter((u) => u.role !== "admin" && u.account_status === "active"))).catch(() => {});
  }, []);
  const save = async (enabled, ids) => {
    try { await api.put("/admin/settings", { marketplace_autobuy_enabled: enabled, marketplace_autobuy_mlos: ids }); setOn(enabled); setOrder(ids); toast.success("Auto-purchase saved"); }
    catch (e) { toast.error(apiError(e)); }
  };
  const move = (i, d) => { const n = [...order]; [n[i], n[i + d]] = [n[i + d], n[i]]; save(on, n); };
  const name = (id) => { const u = mlos.find((m) => m.id === id); return u ? `${u.first_name || ""} ${u.last_name || ""}`.trim() || u.email : "Inactive / removed MLO"; };
  return (
    <Card className="mb-5 p-6" data-testid="autobuy-card">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h3 className="font-semibold text-slate-900">Free auto-purchase</h3>
          <p className="mt-1 text-sm text-slate-500">When on, every new Marketplace lead goes free ($0) to the first active MLO in this list. Order: Ava calls you, the lead is assigned and enriched, Ava calls the MLO, calls the lead to live-transfer or set an appointment, then calls the MLO with the result. MLOs on this list also pay $0 for any lead they buy from the Marketplace; the prices you set apply to every other MLO.</p>
        </div>
        <Switch checked={on} onCheckedChange={(v) => save(v, order)} data-testid="autobuy-toggle" />
      </div>
      <ol className="mt-4 space-y-2">
        {order.length === 0 && <li className="text-sm text-slate-400">No MLOs selected yet.</li>}
        {order.map((id, i) => (
          <li key={id} className="flex items-center justify-between rounded-lg border border-slate-200 px-3 py-2 text-sm" data-testid={`autobuy-mlo-${id}`}>
            <span><b className="mr-2 text-slate-400">{i + 1}.</b>{name(id)}{i === 0 && <span className="ml-2 rounded bg-emerald-100 px-1.5 py-0.5 text-xs text-emerald-800">gets leads</span>}</span>
            <span className="flex gap-1">
              <Button size="icon" variant="ghost" disabled={i === 0} onClick={() => move(i, -1)} data-testid={`autobuy-up-${id}`}><ArrowUp className="h-4 w-4" /></Button>
              <Button size="icon" variant="ghost" disabled={i === order.length - 1} onClick={() => move(i, 1)} data-testid={`autobuy-down-${id}`}><ArrowDown className="h-4 w-4" /></Button>
              <Button size="icon" variant="ghost" onClick={() => save(on, order.filter((x) => x !== id))} data-testid={`autobuy-remove-${id}`}><X className="h-4 w-4" /></Button>
            </span>
          </li>))}
      </ol>
      <div className="mt-3 flex flex-wrap gap-2">
        <select value={pick} onChange={(e) => setPick(e.target.value)} className="h-9 min-w-0 flex-1 rounded-md border border-slate-200 px-2 text-sm" data-testid="autobuy-select">
          <option value="">Add an MLO…</option>
          {mlos.filter((m) => !order.includes(m.id)).map((m) => <option key={m.id} value={m.id}>{`${m.first_name || ""} ${m.last_name || ""}`.trim() || m.email} · {m.email}</option>)}
        </select>
        <Button variant="outline" disabled={!pick} onClick={() => { save(on, [...order, pick]); setPick(""); }} data-testid="autobuy-add-btn"><Plus className="mr-1 h-4 w-4" />Add</Button>
      </div>
    </Card>
  );
};
